<template>
  <v-app>
    <layout-provider>
      <router-view />
    </layout-provider>

    <app-alert />
  </v-app>
</template>

<script>
import AppAlert from '@/components/AppAlert.vue';
import LayoutProvider from '@/components/LayoutProvider.vue';

export default {
  name: 'App',

  components: {
    AppAlert,
    LayoutProvider,
  },
};
</script>

<style lang="scss" src="./styles/overrides.scss"></style>
